import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const phoneExtGroup = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    updateSequence,
};

const MODULE = {
    PHONE_EXT_GROUP: 'phone-ext-groups',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            phone_ext_uuid: filter?.phoneExtUuid,
            is_active: filter?.isActive,
        },
    };

    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT_GROUP}`, request);
}

export function store (data) {
    const request = {
        phone_ext_uuid: data.phoneExtUuid,
        name: data.name,
        sequence: data.sequence,
    };

    return apiHelper(API_URL).post(`/${MODULE.PHONE_EXT_GROUP}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT_GROUP}/${uuid}`);
}

export function update (data) {
    const request = {
        phone_ext_uuid: data.phoneExtUuid,
        name: data.name,
        sequence: data.sequence,
    };

    return apiHelper(API_URL).put(`/${MODULE.PHONE_EXT_GROUP}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PHONE_EXT_GROUP}/${data.uuid}`, request);
}

export function updateSequence (data) {
    const request = {
        phone_ext_uuid: data.phoneExtUuid,
        groups: (data.groups ?? []).map(item => ({
            uuid: item.uuid,
            sequence: item.sequence,
        })),
    };

    return apiHelper(API_URL).patch(`/${MODULE.PHONE_EXT_GROUP}/sequences`, request);
}